import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { ExperienceIntro } from '../components/home/ExperienceIntro';
import { WorkspaceGrid } from '../components/home/WorkspaceGrid';
import { ResearchWorkflow } from '../components/home/ResearchWorkflow';
import { ModulesShowcase } from '../components/sections/ModulesShowcase';
import { ClosingInvitation } from '../components/sections/ClosingInvitation';
export function Home() {
  return <>
      <HomeHero data-id="element-675" data-mp="1zkaa3brqs3mg" />
      <ExperienceIntro data-id="element-676" data-mp="24gsbq2rrzluk" />
      <WorkspaceGrid data-id="element-677" data-mp="24g8wittifbk8" />
      <ResearchWorkflow data-id="element-678" data-mp="24hk8hgx3zpmf" />
      <ModulesShowcase data-id="element-679" data-mp="24j4ugi5cy08o" />
      <ClosingInvitation title="See Noetivra in your world." body="Explore an interactive workspace or talk with us about a configuration for your organization." primary={{
      label: 'Explore Demos',
      to: '/demos'
    }} secondary={{
      label: 'Discuss Your Workspace',
      to: '/contact'
    }} data-id="element-680" data-mp="29gd9waz4fq68" />
    </>;
}